/**
 * @generated SignedSource<<3a47fed62737309f01e21d018f45da55>>
 * @relayHash a0dc0a296d152cfbd6c0ca2a59e55c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e

import type { ConcreteRequest } from 'relay-runtime';
export type CatchupContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type useNudgeFirstVisitFilterQuery$variables = {
  contentId: string;
  contentType: CatchupContentType;
};
export type useNudgeFirstVisitFilterQuery$data = {
  readonly catchupGetLastViewedTime: {
    readonly lastViewedTimeISO: string | null | undefined;
  } | null | undefined;
};
export type useNudgeFirstVisitFilterQuery = {
  response: useNudgeFirstVisitFilterQuery$data;
  variables: useNudgeFirstVisitFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "CatchupLastViewedTimeResponse",
    "kind": "LinkedField",
    "name": "catchupGetLastViewedTime",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "lastViewedTimeISO"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useNudgeFirstVisitFilterQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNudgeFirstVisitFilterQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a0dc0a296d152cfbd6c0ca2a59e55c8b",
    "id": "80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e",
    "metadata": {},
    "name": "useNudgeFirstVisitFilterQuery",
    "operationKind": "query",
    "text": "query useNudgeFirstVisitFilterQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
  }
};
})();

(node as any).hash = "1e734053e31505b911fcc40be543fe6e";

export default node;
